import { Nav, Offcanvas } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import notAuthUserIcon from "../../../../images/icons/topNavBar/menu/notAuthUser.svg";
import authorizationIcon from "../../../../images/icons/topNavBar/menuItems/authorization.svg";
import registrationIcon from "../../../../images/icons/topNavBar/menuItems/registration.svg";
import { useCallback, useState } from "react";
import { useNavigate } from "react-router";
import { routes } from "../../../../app/routes/routes";
import { useMediaQuery } from "../../../../hooks/useMediaQuery";
import { useUserRole } from "../../../../hooks/useUserRole";
import { UserRolesEnum } from "../../../../app/enums/userRolesEnum";

interface Props {
    onAction?: () => void;
}

const NotAuthUserDropDown = ({ onAction }: Props) => {
    const { t } = useTranslation();
    const navigate = useNavigate();
    const isMobile = useMediaQuery("(max-width: 575px)");
    const [showPanel, setShowPanel] = useState(false);
    const { hasRole } = useUserRole();

    const handleAction = useCallback(
        (path: string) => {
            setShowPanel(false);
            onAction?.();
            navigate(path);
        },
        [navigate, onAction]
    );

    return (
        <>
            <Nav.Item>
                <Nav.Link onClick={() => setShowPanel(true)} className="d-flex align-items-center gap-2">
                    <img src={notAuthUserIcon} alt={t("navbar.topNavBar.user")} />
                    {isMobile && <span>{t("navbar.topNavBar.user")}</span>}
                </Nav.Link>
            </Nav.Item>

            <Offcanvas
                show={showPanel}
                onHide={() => setShowPanel(false)}
                placement={isMobile ? "bottom" : "end"}
                className="top-bar-offcanvas"
                data-bs-theme="dark"
            >
                <Offcanvas.Header closeButton>
                    <Offcanvas.Title>{t("navbar.topNavBar.user")}</Offcanvas.Title>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <Nav className="top-bar-offcanvas__list">
                        <Nav.Item>
                            <Nav.Link onClick={() => handleAction(routes.login.path)} className="d-flex align-items-center gap-2">
                                <img src={authorizationIcon} />
                                <span>{t("navbar.topNavBar.notAuthUser.authorization")}</span>
                            </Nav.Link>
                        </Nav.Item>
                        {/* Registration is temporarily Admin-only; anonymous visitors (the only
                            audience for this dropdown) never have the Admin role, so this stays hidden. */}
                        {hasRole([UserRolesEnum.Admin]) && (
                            <Nav.Item>
                                <Nav.Link onClick={() => handleAction(routes.signUp.path)} className="d-flex align-items-center gap-2">
                                    <img src={registrationIcon} />
                                    <span>{t("navbar.topNavBar.notAuthUser.registration")}</span>
                                </Nav.Link>
                            </Nav.Item>
                        )}
                    </Nav>
                </Offcanvas.Body>
            </Offcanvas>
        </>
    );
};

export default NotAuthUserDropDown;
